import React from "react";
import Style from "./Warning.module.css";

import { RiDeleteBin6Line } from "react-icons/ri";

const DeletionConfirm = ({ onClose, onSucess }) => {

  const handleDelete = async () => {
 onSucess();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className={Style.WarningdeleteConfirmation}>
      <div className={Style.WarningconfirmationCard}>
        <>
          <div className={Style.WarningiconContainer}>
            <RiDeleteBin6Line size={50} color="red" />
          </div>

          <h3>Delete the log</h3>
          <p className={Style.Warrningpara}>This action cannot be undone.</p>

          <div className={Style.WarningbuttonGroup}>
            <button
              className={Style.WarningcancelBtn}
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              className={Style.WarningdeleteBtn}
              onClick={handleDelete}
            >
           
                Delete
         
            </button>
          </div>
        </>
      </div>
    </div>
  );
};

export default DeletionConfirm;
